import script from "./RoomDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomDetailView.vue?vue&type=script&setup=true&lang=js"

import "./RoomDetailView.vue?vue&type=style&index=0&id=0c61ac7c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c61ac7c"]])

export default __exports__